import Immutable from 'immutable';
import * as CruiseListActionTypes from '../../actionTypes/cruiseListActionTypes';
import { CRUISE_LIST_SORT_ORDERS } from '../../../constants/sortOrders';
import { urlUtils } from '../../../utils/url';

const sortKeyFromUrl = urlUtils.getSortKeyFromUrl();

const initialState = Immutable.fromJS({
  selected: sortKeyFromUrl || CRUISE_LIST_SORT_ORDERS.DEPARTURE_DATE,
  sortOptions: [],
  sortPanelIsVisible: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case CruiseListActionTypes.INIT_SUCCESS:
      return state.withMutations((s) => {
        s.set('sortOptions',
          Immutable.fromJS([
            {
              name: action.labels.sortLabelDepartureDate,
              value: CRUISE_LIST_SORT_ORDERS.DEPARTURE_DATE,
            },{
              name: action.labels.sortLabelLowestPrice,
              value: CRUISE_LIST_SORT_ORDERS.LOWEST_PRICE,
            },{
              name: action.labels.sortLabelHighestPrice,
              value: CRUISE_LIST_SORT_ORDERS.HIGHEST_PRICE,
            },{
              name: action.labels.sortLabelDuration,
              value: CRUISE_LIST_SORT_ORDERS.DURATION,
            },
          ]),
        );
      });
    case CruiseListActionTypes.SORT_CRUISE_LIST:
      if (state.get('selected') === action.sortBy) {
        return state;
      }
      return state.withMutations((s) => {
        s.set('selected', action.sortBy);
      });
    case CruiseListActionTypes.TOGGLE_SORT_PANEL:
      return state.withMutations((s) => {
        s.set('sortPanelIsVisible', action.isVisible);
      });
    default:
      return state;
  }
};